import MatomoTracker from '@jonkoops/matomo-tracker';

const matomoConfig = document.querySelector<HTMLDivElement>('#matomo-config');

let tracker;
if (matomoConfig) {
    const matomoUrl = matomoConfig.dataset['host'];
    const matomoSiteId = parseInt(matomoConfig.dataset['siteId']);

    tracker = new MatomoTracker({
        urlBase: matomoUrl,
        siteId: matomoSiteId,
    });

    tracker.trackPageView();
}

export default tracker;
